import http from "../../../core/services/http.service";

function getUsers(params = null) {
  return http.get(`/api/v1/users/`, {params});
}

function getUsersForWidget(params = null) {
  return http.get(`/api/v1/users/list/`, {params});
}

function getPermissionGroups(params = null) {
  return http.get(`/api/v1/permissions/`, {params});
}

function createUser(params, expand = 'permissions') {
  return http.post(`/api/v1/users/?expand=${expand}`, params);
}

function updateUser(uuid, params, expand = 'permissions') {
  return http.patch(`/api/v1/users/${uuid}/?expand=${expand}`, params);
}

function removeUser(uuid) {
  return http.delete(`/api/v1/users/${uuid}`)
}

function switchBranch(params) {
  return http.post(`/api/v1/users/switch-branch/`, params);
}

function logOutAllDevices(uuid){
  return http.post(`/api/v1/users/expire-tokens/`, {uuid})
}

export default {
  getUsers,
  removeUser,
  updateUser,
  createUser,
  getUsersForWidget,
  getPermissionGroups,
  switchBranch,
  logOutAllDevices
};
